export default __webpack_public_path__ + "static/media/projectfive.79b93631.jpg";